var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFilterPlayCircleFilledWhite = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.054,
    height: 18.054,
    viewBox: "0 0 18.054 18.054",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18.054,
    height: 18.054,
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.522,15.045a7.522,7.522,0,1,1,7.522-7.522A7.531,7.531,0,0,1,7.522,15.045Zm0-13.54A6.018,6.018,0,1,0,13.54,7.522,6.025,6.025,0,0,0,7.522,1.5Zm-1.5,9.4V4.137l4.513,3.385L6.019,10.907Z",
    transform: "translate(1.505 1.505)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterPlayCircleFilledWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter_play_circle_filled_white.b459aa87.svg";
export { ForwardRef as ReactComponent };